import type { Note, NoteVersion, NoteVersionSummary } from '../types';

const HOUR = 60 * 60 * 1000;
const DAY = 24 * HOUR;
const iso = (offsetMs: number) => new Date(Date.now() - offsetMs).toISOString();

const MEJORAS_WEB_CONTENT = `<p>Dashboard necesita rediseño antes del sprint de marzo. Ideas sueltas mientras las reviso con el equipo:</p>
<ul data-type="taskList">
  <li data-type="taskItem" data-checked="true"><label><input type="checkbox" checked><span></span></label><div><p>Actualizar paleta de colores del dashboard</p></div></li>
  <li data-type="taskItem" data-checked="false"><label><input type="checkbox"><span></span></label><div><p>Simplificar la tabla de tareas atrasadas</p></div></li>
  <li data-type="taskItem" data-checked="false"><label><input type="checkbox"><span></span></label><div><p>Agregar gráfico de eficiencia por proyecto</p></div></li>
</ul>
<p>Pendiente: mandar mockups a Laura para feedback antes del viernes.</p>`;

export const notesMock: Note[] = [
  {
    id: '7891234560001',
    title: 'Mejoras web',
    content: MEJORAS_WEB_CONTENT,
    createdAt: iso(3 * DAY),
    updatedAt: iso(2 * HOUR),
    versionCount: 3,
  },
  {
    id: '7891234560002',
    title: 'Proyecto universidades',
    content:
      '<h2>1.- Diseño de página web</h2><p>Referencias: sitios de UNAM, Tec de Monterrey. Definir paleta y tipografía antes de la siguiente junta.</p>',
    createdAt: iso(10 * DAY),
    updatedAt: iso(10 * DAY),
    versionCount: 0,
  },
  {
    id: '7891234560003',
    title: 'Apuntes rápidos',
    content:
      '<p>Tabla de información, galería de imágenes:</p><table><tbody><tr><td>Sección</td><td>Estado</td></tr><tr><td>Hero</td><td>Listo</td></tr></tbody></table>',
    createdAt: iso(20 * DAY),
    updatedAt: iso(18 * DAY),
    versionCount: 1,
  },
  {
    id: '7891234560004',
    title: 'Ambiental',
    content:
      '<h2>1.- Diseño de página web</h2><p>Checklist de cumplimiento ambiental para el proyecto.</p>',
    createdAt: iso(200 * DAY),
    updatedAt: iso(200 * DAY),
    versionCount: 0,
  },
  {
    id: '7891234560005',
    title: 'Hardware',
    content:
      '<p>Comprar herramientas</p><ul><li>Multímetro</li><li>Cautín</li><li>Cable UTP cat 6</li></ul>',
    createdAt: iso(210 * DAY),
    updatedAt: iso(205 * DAY),
    versionCount: 2,
  },
  {
    id: '7891234560006',
    title: 'Mejoras a corto plazo',
    content:
      '<p>Rediseño</p><blockquote><p>Priorizar accesibilidad y contraste antes que animaciones.</p></blockquote>',
    createdAt: iso(220 * DAY),
    updatedAt: iso(220 * DAY),
    versionCount: 0,
  },
];

/** Only the note with `versionCount: 3` (Mejoras web) has mock history. */
export const noteVersionsMock: Record<string, NoteVersion[]> = {
  '7891234560001': [
    {
      id: '9001',
      versionNumber: 3,
      title: 'Mejoras web',
      content:
        '<p>Dashboard necesita rediseño antes del sprint de marzo. Ideas sueltas mientras las reviso con el equipo:</p><ul data-type="taskList"><li data-type="taskItem" data-checked="false"><label><input type="checkbox"><span></span></label><div><p>Actualizar paleta de colores del dashboard</p></div></li><li data-type="taskItem" data-checked="false"><label><input type="checkbox"><span></span></label><div><p>Simplificar la tabla de tareas atrasadas</p></div></li><li data-type="taskItem" data-checked="false"><label><input type="checkbox"><span></span></label><div><p>Agregar gráfico de eficiencia por proyecto</p></div></li></ul>',
      createdAt: iso(HOUR),
    },
    {
      id: '9002',
      versionNumber: 2,
      title: 'Mejoras web',
      content:
        '<p>Dashboard necesita rediseño antes del sprint de marzo. Ideas sueltas mientras las reviso con el equipo:</p><ul data-type="taskList"><li data-type="taskItem" data-checked="false"><label><input type="checkbox"><span></span></label><div><p>Simplificar la tabla de tareas atrasadas</p></div></li><li data-type="taskItem" data-checked="false"><label><input type="checkbox"><span></span></label><div><p>Agregar gráfico de eficiencia por proyecto</p></div></li></ul>',
      createdAt: iso(DAY),
    },
    {
      id: '9003',
      versionNumber: 1,
      title: 'Mejoras web',
      content:
        '<p>Dashboard necesita rediseño antes del sprint de marzo. Primeras ideas sueltas.</p>',
      createdAt: iso(3 * DAY),
    },
  ],
};

export const noteVersionSummariesMock: Record<string, NoteVersionSummary[]> = Object.fromEntries(
  Object.entries(noteVersionsMock).map(([noteId, versions]) => [
    noteId,
    versions.map(({ id, versionNumber, title, createdAt }) => ({
      id,
      versionNumber,
      title,
      createdAt,
    })),
  ]),
);
